import React, { useContext } from 'react';
import { namedError } from '../../Utils/Logger';
import { IConsent } from './CookieSettingsUtils';

export type ICookieSettingsContext = [
  IConsent,
  (consent: IConsent) => void,
  boolean
];

const defaultValue: ICookieSettingsContext = [
  {},
  () => {
    throw namedError(
      'CookieSettingsContextMissing',
      'Försök att ställa in cookiesettings utanför CookieSettingsContext'
    );
  },
  false,
];

export const EDCookieSettingsContext =
  React.createContext<ICookieSettingsContext>(defaultValue);

export const useCookieSettings = () => useContext(EDCookieSettingsContext);
